module.exports = __webpack_public_path__ + "static/media/jacka-min.8eff87d6.png";